import { useHistory, useParams } from 'react-router-dom';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import GeneralReportLogs from 'flow/components/settings/GeneralReportLogs';
import Page from 'flow/components/Setting/Page';
import { generatePath } from 'flow/utils/router-utils';

const SettingsGeneralReportLogs = () => {
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    return (
        <Page
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.general'], { extensionKey }),
                )
            }
            header={'settings.general.logs.send'}
        >
            <GeneralReportLogs />
        </Page>
    );
};

export default SettingsGeneralReportLogs;
